import { graphql } from '@/gql';
import type { CheckPaymentSourceMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { StripeIntentKind } from '@/use/stripe';

type CheckPaymentSourceParams = {
  userId: string;
  stripeToken?: string | null;
  setupIntentId?: string | null;
  confirmationTokenId?: string | null;
  /** Discriminates whether setupIntentId holds a SetupIntent ('setup') or registration PaymentIntent ('payment'). */
  intentKind?: StripeIntentKind;
};

export const checkPaymentSource = async ({
  userId,
  stripeToken,
  setupIntentId,
  confirmationTokenId,
  intentKind = 'setup',
}: CheckPaymentSourceParams): Promise<string> => {
  const isPaymentIntent = intentKind === 'payment';
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CheckPaymentSource(
        $userId: String!
        $stripeToken: String
        $setupIntentId: String
        $paymentIntentId: String
        $confirmationTokenId: String
      ) {
        checkPaymentSource(
          userId: $userId
          stripeToken: $stripeToken
          setupIntentId: $setupIntentId
          paymentIntentId: $paymentIntentId
          confirmationTokenId: $confirmationTokenId
        )
      }
    `),
    variables: {
      userId,
      stripeToken,
      setupIntentId: isPaymentIntent ? null : setupIntentId,
      paymentIntentId: isPaymentIntent ? setupIntentId : null,
      confirmationTokenId,
    },
  });

  return response.data?.checkPaymentSource ?? '';
};
